import classes from "./classes.module.scss";
import {
	CGUHeader,
	CGUSection1,
	CGUSection2,
	CGUSection3,
	CGUSection4,
	CGUSection5,
	CGUSection6,
	CGUSection7,
	CGUSection8,
	CGUSection9,
	CGUSection9_1,
	CGUSection9_2,
	CGUSection10,
	CGUSection11,
	CGUSection12,
	CGUSection12_1,
	CGUSection12_2,
	CGUSection13,
	CGUSection14,
	CGUSection15,
	CGUSection16,
	CGUSection17,
	CGUSection18,
	CGUFooter,
} from "./sections";

export default function CGU(): React.JSX.Element {
	return (
		<div className={classes["root"]}>
			<CGUHeader />

			<CGUSection1 />
			<CGUSection2 />
			<CGUSection3 />
			<CGUSection4 />
			<CGUSection5 />
			<CGUSection6 />
			<CGUSection7 />
			<CGUSection8 />
			<CGUSection9 />
			<CGUSection9_1 />
			<CGUSection9_2 />
			<CGUSection10 />
			<CGUSection11 />
			<CGUSection12 />
			<CGUSection12_1 />
			<CGUSection12_2 />
			<CGUSection13 />
			<CGUSection14 />
			<CGUSection15 />
			<CGUSection16 />
			<CGUSection17 />
			<CGUSection18 />
			<CGUFooter />
		</div>
	);
}
